import { jsx as n } from "react/jsx-runtime";
import "react";
import { NavList as o } from "../NavList/NavList.js";
import '../../assets/InlineNavigation.css';const l = {
  "inline-navigation": "_inline-navigation_3u114_1"
};
function c({ links: t = [], classname: i = "", position: e = "left" }) {
  const a = /* @__PURE__ */ new Map([
    ["left", "flex-start"],
    ["right", "flex-end"],
    ["center", "center"]
  ]);
  return /* @__PURE__ */ n(
    "nav",
    {
      className: l["inline-navigation"],
      style: {
        "--inline-nav-justify-content": a.get(e)
      },
      children: /* @__PURE__ */ n(o, { links: t, classname: i })
    }
  );
}
export {
  c as InlineNavigation,
  c as default
};
